import React from "react";

export type AvatarMediaProps = {
	src: string;
	alt: string;
	className?: string;
};

const videoExtensions = new Set([".mp4", ".webm", ".mov"]);

// The filestore stores animated gif avatars as silent mp4, which an <img>
// cannot show. A video URL gets a looping muted <video> styled like the <img>.
export function isVideoUrl(url: string): boolean {
	let path = url;
	try {
		path = new URL(url, "https://placeholder.invalid").pathname;
	} catch {
		return false;
	}
	const dot = path.lastIndexOf(".");
	return dot >= 0 && videoExtensions.has(path.slice(dot).toLowerCase());
}

export default function AvatarMedia({ src, alt, className }: AvatarMediaProps) {
	if (isVideoUrl(src)) {
		return (
			<video
				src={src}
				className={className}
				autoPlay
				loop
				muted
				playsInline
				preload="auto"
				aria-label={alt || undefined}
				aria-hidden={alt ? undefined : "true"}
			/>
		);
	}
	return (
		<img
			src={src}
			alt={alt}
			aria-hidden={alt ? undefined : "true"}
			className={className}
		/>
	);
}
